import { PlusOutlined } from '@ant-design/icons'
import { Button, Form } from 'antd'
import { FC } from 'react'

interface AddFormButtonProps {
    onClick: () => void
}

const AddFormButton: FC<AddFormButtonProps> = ({ onClick }) => {
    return (
        <Form.Item label={' '}>
            <Button icon={<PlusOutlined />} type={'dashed'} onClick={onClick}>
                Добавить форму
            </Button>
        </Form.Item>
    )
}

export default AddFormButton
